import type { StepState } from "./types";

export const getStepState = ({
  activeStep,
  index,
}: {
  activeStep: number;
  index: number;
}): StepState => {
  if (activeStep === index + 1) {
    return "current";
  } else if (index + 1 < activeStep) {
    return "complete";
  }

  return "future";
};
